export default __webpack_public_path__ + "static/media/SDG-icon-NL-17.ee632e30.svg";